import {
    GET_COMPANY_USERS_SUCCESS,
    GET_COMPANY_USERS_FAIL,
    ADD_NEW_COMPANY_USER_SUCCESS,
    ADD_NEW_COMPANY_USER_FAIL,
    UPDATE_COMPANY_USER_SUCCESS,
    UPDATE_COMPANY_USER_FAIL,
    DELETE_COMPANY_USER_SUCCESS,
    DELETE_COMPANY_USER_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    users: [],
    error: {},
}

const CompanyUsers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_COMPANY_USERS_SUCCESS:
            return {
                ...state,
                users: action.payload,
            }

        case GET_COMPANY_USERS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_NEW_COMPANY_USER_SUCCESS:
            return {
                ...state,
                users: [...state.users, action.payload],
            }

        case ADD_NEW_COMPANY_USER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_COMPANY_USER_SUCCESS:
            return {
                ...state,
                users: state.users.map(user =>
                    user.id.toString() === action.payload.id.toString()
                        ? { ...user, ...action.payload }
                        : user
                ),
            }

        case UPDATE_COMPANY_USER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_COMPANY_USER_SUCCESS:
            return {
                ...state,
                users: state.users.filter(
                    user => user.id.toString() !== action.payload.toString()
                ),
            }

        case DELETE_COMPANY_USER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default CompanyUsers
